<template>
  <div class="main">
    <div class="am-main-box am-main-top-box">
        <div class="am-main-box-title am-main-top-box-title system-font">Commission Filings</div>
        <a class="icons-links" href="#" title="Commission Reconciliation Part 2" @click.prevent="secondVideo()">
          <svg-icon icon="video" title="Commission Reconciliation Part 2" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
        <a class="icons-links" href="#" title="Commission Reconciliation Part 1" @click.prevent="video()">
          <svg-icon icon="video" title="Commission Reconciliation Part 1" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
        <router-link class="icons-links" :to="{name: 'commissions.reconcile.main', query: {status: 0}}" title="Back">
          <svg-icon icon="back" title="Back" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </router-link>
        <a class="icons-links" href="#" title="Help" @click.prevent="startHelpTour">
          <svg-icon icon="help" title="Help" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
        <a class="icons-links" href="/downloadCommissions.php" title="Import Commissions">
          <svg-icon icon="import" title="Import Commissions" class="am-glyphicon-medium am-glyphicon-white"></svg-icon>
        </a>
    </div>
    <div class="content system-font">
        <div class="am-main-top-box am-main-top-box-title wide">Add New</div>
        <div class="border-bottom border-right border-left border-info">
            <div class="alert alert-danger" role="alert" v-show="error">{{ error }}</div>
            <table>
                <tr>
                    <td><label class="create-row">Company:</label></td>
                    <td><select class="input-field" name="company_id" v-model="form.company"><option value="0">- All Companies -</option><option v-for="c in companies" :key="c.id" :value="c.id">{{ c.name }}</option></select></td>
                </tr>
                <tr>
                    <td><input class="create-row" id="forwardOnly" type="checkbox" v-model="form.forwardOnly" /><label class="detail-label" for="forwardOnly">Forwarded Details Only</label></td>
                    <td></td>
                </tr>
                <tr v-if="!form.forwardOnly">
                    <td><label class="create-row">From:</label></td>
                    <td><input class="input-field" type="date" v-model="form.start" /></td>
                </tr>
                <tr v-if="!form.forwardOnly">
                    <td><label class="create-row">To:</label></td>
                    <td><input class="input-field" type="date" v-model="form.end" /></td>
                </tr>
                <tr v-if="!form.forwardOnly">
                    <td><label class="create-row">Deposit Date:</label></td>
                    <td><input class="input-field" type="date" v-model="form.deposit" /></td>
                </tr>
            </table>
        </div>
    </div>
    <div class="am-main-box am-main-bottom-box">
        <a class="save-button" href="#" @click.prevent="submit">
            <img src="@/assets/save.png">
        </a>
    </div>
    <v-tour name="helpTour" :steps="steps"></v-tour>
    <play-video v-show="showVideoModal" :videoCode="videoCode" :videoType="videoType"></play-video>
</div>
</template>

<script>
import moment from 'moment'
import Datepicker from 'vuejs-datepicker'
import makesAjaxRequests from '@/mixins/makesAjaxRequests'
import PlayVideo from '@/components/PlayVideo.vue'

export default {
  name: 'FileCreateForm',

  mixins: [makesAjaxRequests],

  components: {
    Datepicker,
    PlayVideo,
  },

  data () {
    return {
      companies: [],
      showVideoModal: false,
      videoCode: '181821236',
      videoType: 'vimeo',
      form: {
        company: 0,
        forwardOnly: null,
        start: moment().startOf('month').format('YYYY-MM-DD'),
        end: moment().endOf('month').format('YYYY-MM-DD'),
        deposit: moment().format('YYYY-MM-DD')
      },
      steps: [
        {
          target: "select[name='company_id']",
          content: '<p>The company you select will be used as the pivot for the commission process.</p>' +
            '<p>We will look at every policy written with the company you choose and determine if there was ' +
            'any activity that should have generated commission for your agency.</p>' +
            'Note: If you have a large number of products and select "All Companies" then it may take a ' +
            'while for us to scrub your data and find your commissions.'
        },
        {
          target: 'table > tr:nth-child(4) > td:nth-child(2) > input',
          content: 'The date range will be used to look for commission generation activity.<br>' +
            'Ex: If you wrote policy which goes into effect between the "start" and "end" date and the ' +
            'carrier pays you on "effective" then you can expect to see a detail item for that policy.'
        },
        {
          target: 'table > tr:nth-child(5) > td:nth-child(2) > input',
          content: 'The date in which the carrier deposited funds into your account.'
        }
      ]
    }
  },

  created () {
    this.fetchCompanies()
  },

  methods: {
    async fetchCompanies () {
      this.companies = await this.ajaxCall(this.$http.get('companies').then(resp => resp.data))
    },

    async submit () {
      var { company, forwardOnly, start, end, deposit } = this.form

      this.error = ''
      if (moment(start).isAfter(end)) {
        this.error += 'Start date must be before end date\n'
        return
      }

      this.ajaxCall(this.$http.post('commission/file/create', {
        company,
        forwardOnly,
        start: moment(start).format('YYYY-MM-DD'),
        end: moment(end).format('YYYY-MM-DD'),
        deposit: moment(deposit).format('YYYY-MM-DD')
      })).then(resp => {
        this.fileCreated(resp.data)
      })
    },

    fileCreated (file) {
      this.$router.push({
        name: 'commissions.reconcile.file',
        params: { id: file.id }
      })
    },

    video: function () {
      this.showVideoModal = true
      this.videoCode = '181821236'
      this.$modal.show('playVideo')
    },

    secondVideo: function () {
      this.showVideoModal = true
      this.videoCode = '181821523'
      this.$modal.show('playVideo')
    },

    startHelpTour () {
      this.$tours['helpTour'].start()
    }
  }
}
</script>

<style lang="sass">
  .main
    border: 1px solid #AAAAAA
    margin: 12px 0 30px 12px
    background-color: #F6F6F6
    min-width: 450px
    float: left
    border-radius: 6px

  .am-main-box
    background: #2A95CC repeat-x
    height: 37px
    font-size: 11px
    font-weight: bold

  .am-main-box-title
    color: #FFFFFF
    padding: 10px 10px 0 10px
    float: left

  .icons-links
    color: #FFFF00
    padding: 8px 3px 0 3px
    float: right

  .content
    padding: 16px 16px 26px 16px

  .save-button
    color: #FFFF00
    float: left
    padding-top: 5px
    padding-left: 8px

  .system-font
    font-family: Arial, Helvetica, sans-serif

  .system-green
    background-color: #87bb00
    color: white

  .wide
    width: 600px
    padding: 5px 10px 5px 10px

  .input-field
    margin-left: 40px
    background-color: #ffffef

  .create-row
    margin-left: 10px

  .detail-label
    padding-left: 5px
    vertical-align: middle

  label
    font-weight: bold
    font-size: 11px
</style>
